<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Cobranzas</h1>
                <div class="caption">
                    Muestra montos facturados y cobrados en el periodo seleccionado del grupo y por tipo de fecha seleccionada.
                    Tipo de fecha seleccionada:
                    Fecha de emisión: según fecha de emisión de la factura y fecha de emisión de recibos.
                    Fecha de vencimiento: según fecha de vencimiento de la factura y fecha de vencimiento de recibos.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa" multiple></empresa-select>
                        <moneda-select v-model="d.moneda"></moneda-select>
                        <v-select
                                :items="tipos"
                                v-model="d.tipo"
                                label="Tipo Fecha"
                                item-text="desig"
                                item-value="id"
                                hide-details
                                required
                        ></v-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import monedaSelect from '../../components/MonedaSelect.vue'
    import moment from 'moment';

    export default {
        components: {empresaSelect, monedaSelect},
        data() {
            return {
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    empresa: [],
                    tipo: 'emision',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                    moneda: 1
                },
                t: {},
                tipos: [
                    {id: 'emision', desig: 'Fecha de emisión'},
                    {id: 'vencimiento', desig: 'Fecha de vencimiento'},
                ],
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x',
                        animation: true
                    },
                    title: {
                        text: 'COBRANZAS'
                    },
                    legend: {
                        labelFormat: '{name}'
                    },
                    tooltip: {
                        pointFormat: '<span>{series.name}</span>: <b>$ {point.y:,.2f}</b><br/>',
                        shared: false
                    },
                    xAxis: {
                        type: 'category',
                        minRange: 1
                    },
                    yAxis: {
                        title: {
                            text: 'Montos'
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            }
                        }
                    },
                    plotOptions: {
                        column: {
                            stacking: false,
                            dataLabels: {
                                align: 'left',
                                enabled: false,
                                rotation: -45,
                                format: '$ {y:,.2f}'
                            }
                        }
                    },
                    series: []
                },
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/cobranzas', this.d)
                    .then(r => {
                        if (r.data.type === 'error') {
                            this.loading = false;
                            return false
                        }
                        this.chartOptions.series = r.data.datos;
                        this.t = r.data.totales;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        err(r)
                    });

            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/cobranzas.vue